import { useState, useEffect } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { trackDemoClick } from '../../lib/analytics'

const BOOK = 'https://outlook.office.com/book/WelcometoCorpstage@corpstage.com/?ismsaljsauthenabled'

const LINKS = [
  { label: 'Platform', to: '/platform' },
  { label: 'Solutions', to: '/solutions' },
  { label: 'Case Studies', to: '/case-studies' },
  { label: 'Academy', to: '/academy' },
  { label: 'Insights', to: '/insights' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
]

export default function Nav() {
  const [open, setOpen] = useState(false)
  const [loginOpen, setLoginOpen] = useState(false)
  const location = useLocation()
  useEffect(() => { setOpen(false); setLoginOpen(false) }, [location])

  return (
    <header className="nav">
      <Link to="/" className="nav-logo">
        <img src="/brand/cs-icon.svg" alt="CorpStage" />
        <span className="nav-logo-text">CorpStage</span>
      </Link>

      <button className="nav-burger" aria-label="Menu" onClick={() => setOpen(o => !o)}>
        <span /><span /><span />
      </button>

      <nav className={`nav-links ${open ? 'open' : ''}`}>
        {LINKS.map(l => (
          <NavLink key={l.to} to={l.to} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            {l.label}
          </NavLink>
        ))}
        <NavLink to="/ask-iris" className="nav-link iris">✦ Ask IRIS</NavLink>

        <div className="nav-login-wrap" onMouseLeave={() => setLoginOpen(false)}>
          <button className="nav-login-btn" onClick={() => setLoginOpen(o => !o)} onMouseEnter={() => setLoginOpen(true)}>Login ▾</button>
          {loginOpen && (
            <div className="nav-dropdown">
              <a href="https://corpstage.app" target="_blank" rel="noreferrer">CorpStage ESG 360 →</a>
              <a href="https://aivara.corpstage.app" target="_blank" rel="noreferrer">AIVARA Core 360 →</a>
              <Link to="/portal/login">CorpStage Portal →</Link>
            </div>
          )}
        </div>

        <a href={BOOK} target="_blank" rel="noreferrer" className="nav-cta" onClick={() => trackDemoClick(location.pathname)}>Book a Demo</a>
      </nav>
    </header>
  )
}
